import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PropertySteps } from '../../../../enums/property-steps.enum';
import { PropertyUsageComponent } from './steps/property-usage/property-usage.component';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { StepperProgressBarService } from '../../../../services/stepper-progress-bar.service';
import { AboutYouSteps } from '../../../../enums/about-you-steps.enum';

@Component({
  selector: 'lgv-property-section',
  standalone: true,
  imports: [CommonModule,
    PropertyUsageComponent, MatProgressBarModule],
  templateUrl: './property-section.component.html',
  styleUrls: ['./property-section.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PropertySectionComponent {

  @Input() specificStep = '';
  @Output() sectionChange = new EventEmitter<any>();

  sectionTitle = 'Property'
  PropertySteps = PropertySteps
  public currentStep: any = PropertySteps.PropertyUsage

  get progress(): number {
    return this.progressService.calculateProgressPreApproval(this.currentStep);
  }

  constructor(
    public progressService: StepperProgressBarService
  ) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['specificStep']) {
      this.currentStep = this.specificStep || PropertySteps.PropertyUsage;
    }
  }

  goToStep(event: any) {
    this.currentStep = event
  }

  goToSection(event: any) {
    this.sectionChange.emit(event);
  }
}
